export interface StepProps {
  uid: OnboardingStepType;
  nodeType: OnboardingNodeType;
  displayName: string;
  actionButtonText: string;
}

export interface RedirectingStepProps extends StepProps {
  redirectToNodeType: OnboardingNodeType;
}

export enum OnboardingNodeType {
  EMAIL = 'email',
  PASSWORD = 'password',
  FIRST_NAME = 'first_name',
  FINAL_DETAILS = 'final_details',
  INSURANCE_TYPE = 'insurance_type',
  INSURANCE_PROVIDER = 'insurance_provider',
  INSURANCE_DETAILS = 'insurance_details',
  JURISDICTION = 'jurisdiction',
  PRIMARY_SUBSTANCE = 'primary_substance',
  RECOVERY_GOAL = 'recovery_goal',
  TOOLS_AND_MOTIVATION = 'tools_and_motivation',
  PHONE_NUMBER = 'phone_number',
  HOW_DID_YOU_HEAR_ABOUT_US = 'how_did_you_hear_about_us',
  TREATMENT_PREFERENCE = 'treatment_preference'
}

export enum OnboardingStepType {
  EMAIL = 'email',
  PASSWORD = 'password',
  FIRST_NAME = 'first_name',
  FINAL_DETAILS = 'final_details',
  INSURANCE_TYPE = 'insurance_type',
  INSURANCE_PROVIDER = 'insurance_provider',
  INSURANCE_DETAILS_MEDICAID = 'insurance_details_medicaid',
  INSURANCE_DETAILS_OTHER = 'insurance_details_other',
  INSURANCE_DETAILS_NO_INSURANCE = 'insurance_details_no_insurance',
  JURISDICTION = 'jurisdiction',
  PRIMARY_SUBSTANCE = 'primary_substance',
  RECOVERY_GOAL = 'recovery_goal',
  TOOLS_AND_MOTIVATION = 'tools_and_motivation',
  PHONE_NUMBER = 'phone_number',
  HOW_DID_YOU_HEAR_ABOUT_US = 'how_did_you_hear_about_us',
  TREATMENT_PREFERENCE = 'treatment_preference'
}
